import { Flex, Image, Title, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Feature_Items } from "~/core";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

export const RowItem: FC<Feature_Items> = ({
  image,
  title,
  description,
  additional_image,
}) => {
  const { getDirectusImage } = useDirectus();
  const mImage = additional_image?.image?.id ?? "";
  const mdImage = additional_image?.tablet_image?.id ?? mImage;
  const dImage = additional_image?.desktop_image?.id ?? mdImage;
  return (
    <Flex
      flexDirection="column"
      align="center"
      className="flex-1"
      horizontalAlign="center"
      md={{ minWidth: 312 }}
    >
      {image?.id && (
        <Image
          m={{ mb: 8, mx: "auto" }}
          md={{ m: { mb: 24 } }}
          className="block"
          value={getDirectusImage(image?.id ?? "", {
            format: "webp",
          })}
        />
      )}
      <Title
        size="small"
        as="h3"
        fontWeight="mobile.semibold"
        fontSize="title.mobile.medium"
        lineHeight="title.mobile.medium"
        md={{
          weight: "bold",
          fontWeight: "desktop.bold",
          fontSize: "title.desktop.small",
          lineHeight: "title.desktop.small",
        }}
        m={{ mb: 8 }}
      >
        {title}
      </Title>

      {description && (
        <Typography
          size="medium"
          horizontalAlign="center"
          d={{ horizontalAlign: "center" }}
          m={{ mb: 8 }}
        >
          {description}
        </Typography>
      )}
      {additional_image?.image && (
        <Image
          value={getDirectusImage(mImage, {
            format: "webp",
            width: additional_image.mobile_image_width ?? undefined,
            height: additional_image.mobile_image_height ?? undefined,
          })}
          mdValue={getDirectusImage(mdImage, {
            format: "webp",
            width: additional_image.tablet_image_width ?? undefined,
            height: additional_image.tablet_image_height ?? undefined,
          })}
          dValue={getDirectusImage(dImage, {
            format: "webp",
            width: additional_image.desktop_image_width ?? undefined,
            height: additional_image.desktop_image_height ?? undefined,
          })}
        />
      )}
    </Flex>
  );
};
